import { Route } from '@angular/router';
import { assistantCanActiveGuard } from '@rma/dashboard/assistant-access/public/util-assistant-guards';
import unsubscribeRoutes from '@rma/dashboard/billing/cancel/unsubscribe';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/dashboard/generic/util/router-utils';

export const billingRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/manage-account/billing',
  },
  {
    path: 'start-trial',
    redirectTo: '/plans',
  },

  // Remove after 2024-06-30 still used in promoter and Rma.ReviewPromotion.TaxInvoice.sql (2025-06-23)
  {
    path: 'account',
    canActivate: [logRedirectGuard('/manage-account/billing')],
    component: RmaEmptyComponent,
  },
  // Remove after 2024-06-30 still used in billing api EmailService (2025-06-23)
  {
    path: 'my-subscription',
    canActivate: [logRedirectGuard('/manage-account/subscription')],
    component: RmaEmptyComponent,
  },
  {
    path: 'plans',
    data: {
      hideUpgradeButton: true,
    },
    loadComponent: () => import('@rma/dashboard/billing/subscription-plans/subscription-plans'),
    canActivate: [assistantCanActiveGuard],
  },
  {
    path: 'checkout',
    data: {
      hideUpgradeButton: true,
    },
    loadChildren: () => import('@rma/dashboard/billing/checkout/checkout-flow'),
    canActivate: [assistantCanActiveGuard],
  },
  {
    path: 'downgrade',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    loadComponent: () => import('@rma/dashboard/billing/cancel/downgrade'),
    canActivate: [assistantCanActiveGuard],
  },

  {
    path: 'subscription-features',
    title: 'Ready to boost your online presence',
    data: { hideRmaHeader: true, hideRmaSideNav: true },
    loadComponent: () => import('@rma/dashboard/billing/feature-primers/subscription-primer'),
    canActivate: [assistantCanActiveGuard],
  },
  {
    path: 'free-trial',
    component: RmaEmptyComponent,
    canActivate: [
      logRedirectGuard('/billing/subscription-features', {
        source: 'free-trial',
      }),
    ],
  },
  {
    path: 'why-trial-realtor',
    component: RmaEmptyComponent,
    canActivate: [
      logRedirectGuard('/billing/subscription-features', {
        source: 'why-trial-realtor',
      }),
    ],
  },
  {
    path: 'google-profile-upgrade',
    component: RmaEmptyComponent,
    canActivate: [
      logRedirectGuard('/billing/subscription-features', {
        source: 'google-profile-upgrade',
      }),
    ],
  },
  {
    path: 'social-media-pro',
    component: RmaEmptyComponent,
    canActivate: [
      logRedirectGuard('/billing/subscription-features', {
        source: 'social-media-pro',
      }),
    ],
  },
  {
    path: 'review-journey-upgrade',
    component: RmaEmptyComponent,
    canActivate: [
      logRedirectGuard('/billing/subscription-features', {
        source: 'review-journey-upgrade',
      }),
    ],
  },
  ...unsubscribeRoutes,
];
